/* eslint no-underscore-dangle: "off" */

import Api from 'Helpers/api';
import queryString from 'query-string';

const Orders = {
	fetch: async (params = {}) => {
		params._sort = 'updatedAt:DESC';
		params._start = 0;
		params._limit = 100;
		const response = await Api.call('get', `/orders?${queryString.stringify(params)}`);
		return response.data || [];
	},
	getLastSync: async () => {
		const params = {
			_limit: 1,
			_sort: 'createdAt:DESC'
		};
		const response = await Api.call('get', `/last-syncs?${queryString.stringify(params)}`);
		return response.data[0] && response.data[0].epoch && parseInt(response.data[0].epoch, 10);
	},
	sync: async () => {
		try {
			const response = await Api.call('get', '/orders/sync');
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	getCount: async (params) => {
		const response = await Api.call('get', `/orders/count?${queryString.stringify(params)}`);
		return response.data;
	},
	update: async (id, params) => {
		const response = await Api.call('put', `/orders/${id}`, params);
		return response.data;
	},
	search: async (query) => {
		const queryParams = `_where[order_number_eq]=${query}`;
		
		console.log('queryParams', queryParams);
		const response = await Api.call('get', `/orders?${queryParams}`);
		return response.data;
	}
};

export default Orders;
